import { PaginatedResponse } from '@vadiun/react-datatable';
import moment from 'moment';
import { httpClient } from 'shared/services/http/httpClient';
import { DriverIncomeFiltersFormType } from '../components/DriverIncomeFiltersForm';
import { DriverIncomeModel } from '../models/DriverIncomeModel';

export const useDriverIncomeRepository = () => {
  const getIncomeReport = async (
    page: number,
    rowsPerPage: number,
    sortBy: string,
    sortDir: string,
    filters: DriverIncomeFiltersFormType
  ): Promise<PaginatedResponse<DriverIncomeModel>> => {
    const params = new URLSearchParams();
    params.append('page', String(page));
    params.append('page_size', String(rowsPerPage));
    params.append('sort', sortBy);
    params.append('dir', sortDir);
    if (filters.from) params.append('from', filters.from.format('YYYY-MM-DD'));
    if (filters.to) params.append('to', filters.to.format('YYYY-MM-DD'));
    if (filters.turnoAbierto) params.append('turno_abierto', '1');
    filters.driver_ids.forEach((id) => params.append('driver_ids[]', String(id)));

    const res = await httpClient.get(`drivers/income-report?${params.toString()}`);

    return {
      total: res.meta.total,
      data: res.data.map((r: any) => ({
        ...r,
        shift_open_date_time:
          r.shift_open_date_time === null ? null : moment(r.shift_open_date_time)
      }))
    };
  };

  return { getIncomeReport };
};
